var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.675 20.675a8.182 8.182 0 0 1-9.35-9.35 8.182 8.182 0 0 1 9.35 9.35zm3.506-1.437C24.09 12.972 19.029 7.91 12.763 7.82A8.182 8.182 0 1 1 24.18 19.238zm-.724 4.218C27.862 21.814 31 17.569 31 12.59 31 6.19 25.81 1 19.41 1c-4.98 0-9.224 3.138-10.866 7.544C4.138 10.186 1 14.431 1 19.41 1 25.81 6.19 31 12.59 31c4.98 0 9.224-3.138 10.866-7.544zm-4.218.725C12.972 24.09 7.91 19.029 7.82 12.763A8.182 8.182 0 1 0 19.238 24.18z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/CELO.b902977295d120ace72aa9630b7fa8f6.svg";
export { ForwardRef as ReactComponent };